export default function initImageTextListing() {
  document.querySelectorAll(".listing-section").forEach((section) => {
    section.querySelectorAll(".listing-item").forEach((item) => {
      const description = item.querySelector(".description")
      const link = description ? description.querySelector("a[href]") : null

      if (link && link.getAttribute("href")) {
        const href = link.getAttribute("href")
        const newLink = document.createElement("a")

        // Copy classes and attributes from original .listing-item
        newLink.className = item.className
        newLink.setAttribute("href", href)

        // Move all child nodes to new <a> tag
        while (item.firstChild) {
          newLink.appendChild(item.firstChild)
        }

        // Replace the old div with the new <a>
        item.parentNode.replaceChild(newLink, item)
      }
    })
  })
}
